'use client';

import { UiKitDialogBase } from '@/fo/ui/kit/dialog/base';
import {
  Product,
  ReviewsData,
  QuestionsData,
  ReviewTab,
  UiReviewCatalogBase
} from '@/fo/ui/review/catalog/base';

import { useQuestions } from '../hooks/useQuestions';
import { useReviews } from '../hooks/useReviews';

export interface FeatureReviewCatalogBaseProps {
  product: Product;
  open?: ReviewTab | null;
  onOpenChange: (open: boolean) => void;
  onImageClick: (imageId: string) => void;
  onClose: () => void;
  onActionClick?: (tab: ReviewTab) => void;
  reviewsData: ReviewsData;
  questionsData: QuestionsData;
}

export function FeatureReviewCatalogBase({
  product,
  open,
  onOpenChange,
  onImageClick,
  onClose,
  onActionClick,
  reviewsData: initialReviewsData,
  questionsData: initialQuestionsData
}: FeatureReviewCatalogBaseProps) {
  const {
    reviewsData,
    reviewsLoading,
    fetchMoreReviews,
    handleFiltersChange,
    showLoadMore
  } = useReviews(product, initialReviewsData);

  const {
    questionsData,
    questionsLoading,
    fetchMoreQuestions,
    handleSortOrderChange
  } = useQuestions(product, initialQuestionsData);

  const handleLoadMore = (tab: ReviewTab) => {
    if (tab === ReviewTab.Reviews) {
      fetchMoreReviews();
    } else {
      fetchMoreQuestions();
    }
  };

  return (
    <UiKitDialogBase
      title={product.title}
      open={!!open}
      onOpenChange={onOpenChange}
      fullScreen
      className="p-0!"
    >
      <div className="container">
        {!!open && (
          <UiReviewCatalogBase
            reviewsData={reviewsData}
            questionsData={questionsData}
            product={product}
            onImageClick={onImageClick}
            onClose={onClose}
            onActionClick={onActionClick}
            onLoadMore={handleLoadMore}
            onFiltersChange={handleFiltersChange}
            onSortTypeChange={handleSortOrderChange}
            isReviewsLoading={reviewsLoading}
            isQuestionsLoading={questionsLoading}
            reviewsShowLoadMore={showLoadMore}
            activeTab={open}
          />
        )}
      </div>
    </UiKitDialogBase>
  );
}
